import { cn } from '@herit-fe/heritage-ui';
import type { MarketItem } from '@/shared/data-types';
import { marketDeltaText, marketDeltaTone, marketPriceText, marketMonthDay } from '@/shared/lib';
import { UI_TEXT } from '@/shared/languages';
import { ElevatedCard } from './elevated-card';

/**
 * 시장가 카드 — SMP·REC 를 한 줄에 나란히, 각 항목 `[라벨(기준일)][현재가][전일대비]`. `flex-wrap` — 폭이 좁아
 * 둘이 안 들어가면 REC 가 아래 줄로 떨어짐(오버플로 방지). 2건 미만이면 미표기(구앱 정합, `buildMarketItems`).
 *
 * 대시보드(전체·단일)와 수익분석이 **동일 모양**을 쓰도록 shared 로 올린 시장가 표시 SSOT(위젯끼리는 동일 레이어라
 * 직접 공유 불가).
 */
export function MarketCard({ items }: { items: MarketItem[] }) {
  if (items.length === 0) return null;
  return (
    <ElevatedCard className="p-4">
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-1">
        {items.map((item) => {
          const label =
            item.kind === 'smp' ? UI_TEXT.REVENUE_MARKET_SMP : UI_TEXT.REVENUE_MARKET_REC;
          // 기준 시점은 라벨 뒤 괄호로 — 값(가격·등락) 옆에 두면 숫자 셋이 붙어 날짜도 수치로 읽힌다.
          // 날짜 결측(비정상 포맷)이면 괄호 자체를 안 붙인다.
          const date = marketMonthDay(item.date);
          return (
            <div key={item.kind} className="flex items-center gap-2 text-sm tabular-nums">
              <span className="text-muted-foreground">{date ? `${label}(${date})` : label}</span>
              <span className="font-semibold text-foreground">{marketPriceText(item)}</span>
              <span className={cn('text-xs', marketDeltaTone(item.delta))}>
                {marketDeltaText(item)}
              </span>
            </div>
          );
        })}
      </div>
    </ElevatedCard>
  );
}
